module.exports = __webpack_public_path__ + "img/ala-trucking.55d24480.jpg";